import { Category, Segment } from '@/data/mockData';

interface ApiSegment {
  name: string;
  type: string;
}

export interface ApiAvailableSegments {
  [categoryName: string]: ApiSegment[];
}

const slugify = (value: string): string =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const mapApiSegmentsToCategories = (
  availableSegments: ApiAvailableSegments | undefined,
  referenceCategories: Category[]
): Category[] => {
  if (!availableSegments) {
    return [];
  }

  const categories: Category[] = [];

  Object.entries(availableSegments).forEach(([categoryName, apiSegments]) => {
    if (!Array.isArray(apiSegments) || apiSegments.length === 0) {
      return;
    }

    const refCategory = referenceCategories.find(
      (cat) => cat.name.toLowerCase() === categoryName.toLowerCase()
    );

    const segments: Segment[] = apiSegments.map((apiSegment) => {
      const baseId = `${categoryName}__${apiSegment.name}`;
      const id = slugify(baseId);

      return {
        id,
        name: apiSegment.name,
        // Les volumes seront injectés par mapApiEstimationToSegmentVolumes après l'appel API
      } as Segment;
    });

    categories.push({
      id: slugify(categoryName),
      name: categoryName,
      segments,
    });
  });

  return categories;
};


